"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconPerson', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M12.8 13.6H3.19837L3.19757 12.8608C3.41677 9.9992 5.39037 8 7.99997 8C10.6 8 12.5704 9.9848 12.8 12.8312V13.6ZM5.99998 4.4C5.99998 3.2968 6.89678 2.4 7.99998 2.4C9.10318 2.4 9.99998 3.2968 9.99998 4.4C9.99998 5.5032 9.10318 6.4 7.99998 6.4C6.89678 6.4 5.99998 5.5032 5.99998 4.4V4.4ZM14.3976 12.7392C14.188 9.996 12.7096 7.8656 10.5592 6.9264C11.2016 6.2768 11.6 5.384 11.6 4.4C11.6 2.4152 9.98478 0.799999 7.99998 0.799999C6.01518 0.799999 4.39998 2.4152 4.39998 4.4C4.39998 5.384 4.79838 6.2768 5.44158 6.9272C3.29118 7.8696 1.81118 10.0128 1.59998 12.8V14.4C1.59998 14.8424 1.95758 15.2 2.39998 15.2H13.6C14.0424 15.2 14.4 14.8424 14.4 14.4V12.8C14.4 12.78 14.3992 12.7592 14.3976 12.7392V12.7392Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M16 17H3.998L3.997 16.076C4.271 12.499 6.738 10 10 10C13.25 10 15.713 12.481 16 16.039V17ZM7.5 5.5C7.5 4.121 8.621 3 10 3C11.379 3 12.5 4.121 12.5 5.5C12.5 6.879 11.379 8 10 8C8.621 8 7.5 6.879 7.5 5.5V5.5ZM17.997 15.924C17.735 12.495 15.887 9.832 13.199 8.658C14.002 7.846 14.5 6.73 14.5 5.5C14.5 3.019 12.481 1 10 1C7.519 1 5.5 3.019 5.5 5.5C5.5 6.73 5.998 7.846 6.802 8.659C4.114 9.837 2.264 12.516 2 16V18C2 18.553 2.447 19 3 19H17C17.553 19 18 18.553 18 18V16C18 15.975 17.999 15.949 17.997 15.924V15.924Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M19.2 20.4H4.79762L4.79642 19.2912C5.12522 14.9988 8.08562 12 12 12C15.9 12 18.8556 14.9772 19.2 19.2468V20.4ZM9.00002 6.6C9.00002 4.9452 10.3452 3.6 12 3.6C13.6548 3.6 15 4.9452 15 6.6C15 8.2548 13.6548 9.6 12 9.6C10.3452 9.6 9.00002 8.2548 9.00002 6.6V6.6ZM21.5964 19.1088C21.282 14.994 19.0644 11.7984 15.8388 10.3896C16.8024 9.4152 17.4 8.076 17.4 6.6C17.4 3.6228 14.9772 1.2 12 1.2C9.02282 1.2 6.60002 3.6228 6.60002 6.6C6.60002 8.076 7.19762 9.4152 8.16242 10.3908C4.93682 11.8044 2.71682 15.0192 2.40002 19.2V21.6C2.40002 22.2636 2.93642 22.8 3.60002 22.8H20.4C21.0636 22.8 21.6 22.2636 21.6 21.6V19.2C21.6 19.17 21.5988 19.1388 21.5964 19.1088V19.1088Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M25.6 27.2H6.39681L6.39521 25.7216C6.83361 19.9984 10.7808 16 16 16C21.2 16 25.1408 19.9696 25.6 25.6624V27.2ZM12 8.8C12 6.5936 13.7936 4.8 16 4.8C18.2064 4.8 20 6.5936 20 8.8C20 11.0064 18.2064 12.8 16 12.8C13.7936 12.8 12 11.0064 12 8.8V8.8ZM28.7952 25.4784C28.376 19.992 25.4192 15.7312 21.1184 13.8528C22.4032 12.5536 23.2 10.768 23.2 8.8C23.2 4.8304 19.9696 1.6 16 1.6C12.0304 1.6 8.80001 4.8304 8.80001 8.8C8.80001 10.768 9.59681 12.5536 10.8832 13.8544C6.58241 15.7392 3.62241 20.0256 3.20001 25.6V28.8C3.20001 29.6848 3.91521 30.4 4.80001 30.4H27.2C28.0848 30.4 28.8 29.6848 28.8 28.8V25.6C28.8 25.56 28.7984 25.5184 28.7952 25.4784V25.4784Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;